import { Container, Box, Button } from "@mui/material";
import { NavLink } from "react-router-dom";
import { useIdentity } from "./IdentityProvider";
import WebOnly from "./WebOnly";
import AccountMeta from "./AccountMeta";
import logoImage from "../images/logo.svg";

export default function PageHeader() {
  const identity = useIdentity();
  const linksEnabled = identity.isAuthenticated;

  return (
    <Box
      bgcolor="primary.main"
      paddingTop={4}
      paddingBottom={3}
      position="absolute"
      top={0}
      right={0}
      left={0}
      sx={{
        zIndex: (theme) => theme.zIndex.drawer - 1,
      }}
    >
      <Container maxWidth="xl">
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Box display="flex" alignItems="center">
            {linksEnabled ? (
              <NavLink to="/" style={{ margin: 0, padding: 0 }}>
                <img src={logoImage} style={{ height: 23 }} alt="TrueBiz" />
              </NavLink>
            ) : (
              <img src={logoImage} style={{ height: 23 }} alt="TrueBiz" />
            )}
            <WebOnly>
              {linksEnabled && (
                <>
                  <Button
                    component={NavLink}
                    to="/"
                    sx={{
                      borderColor: "white",
                      color: "white",
                      marginLeft: 6,
                      marginTop: -1,
                    }}
                  >
                    Run a Search
                  </Button>
                  <Button
                    component={NavLink}
                    to="/searches"
                    sx={{
                      borderColor: "white",
                      color: "white",
                      marginLeft: 5,
                      marginTop: -1,
                    }}
                  >
                    Previous Searches
                  </Button>
                  <Button
                    component={NavLink}
                    to="/blocked"
                    sx={{
                      borderColor: "white",
                      color: "white",
                      marginLeft: 5,
                      marginTop: -1,
                    }}
                  >
                    Smart Blocklist
                  </Button>
                  <Button
                    component={NavLink}
                    to="/monitoring"
                    sx={{
                      borderColor: "white",
                      color: "white",
                      marginLeft: 5,
                      marginTop: -1,
                    }}
                  >
                    Monitoring
                  </Button>
                  <Button
                    component={NavLink}
                    to="/settings"
                    sx={{
                      borderColor: "white",
                      color: "white",
                      marginLeft: 5,
                      marginTop: -1,
                    }}
                  >
                    Settings
                  </Button>{" "}
                </>
              )}
            </WebOnly>
          </Box>

          <WebOnly>
            <AccountMeta />

            <Button
              component="a"
              href="https://truebiz.io/book-demo"
              target="_blank"
              rel="noreferrer"
              variant="outlined"
              sx={{ borderColor: "white", color: "white" }}
            >
              Submit Feedback
            </Button>
          </WebOnly>
        </Box>
      </Container>
    </Box>
  );
}
